module.exports = __webpack_public_path__ + "f2dd94ebd0f2041b9c707495656a0190.png";